import { DefaultService } from '@/services/DefaultService';

export default class AssTurnoColaboradorService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    findAllByIdTurno (idturno, situacao, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/turno/colaborador/getall/${idturno}.json?situacao=${situacao}&order=${order}&column=${column}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateSituacao(turnousuario) {
        return this._http.post(`${this._env}/sales/turno/colaborador/updatesituacao`, turnousuario, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }

    saveBulk(turnousuario) {
        return this._http.post(`${this._env}/sales/turno/colaborador/insertbulk`, turnousuario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}